// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3QDun","title":"Info_title__2hjFq","selects":"Info_selects__1kIWE","requiredAsterisk":"Info_requiredAsterisk__1DAR4"};